"use client";

import { FormattedMessage } from "react-intl";
import Link from "next/link";
import { useLocale } from "@/app/providers/IntlProvider";
import { useAppDispatch, useAppSelector } from "@/app/store/hooks";
import { accept, reject } from "@/app/store/cookieConsentSlice";
import { sendAudienceConsent } from "@/lib/analytics/audience";

export default function CookieBanner() {
  const dispatch = useAppDispatch();
  const status = useAppSelector((state) => state.cookieConsent.status);
  const { locale } = useLocale();

  if (status !== "unknown") return null;

  return (
    <div
      role="dialog"
      aria-label="Cookies"
      // Phones: tighter box and type, so it covers less of the first screen's buttons, and
      // lifted above the iPhone home bar (viewport-fit=cover).
      className="fixed inset-x-0 bottom-0 z-50 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] sm:p-6"
    >
      <div className="mx-auto max-w-3xl rounded-xl bg-surface shadow-lg ring-1 ring-slate-200 p-4 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
        <p className="text-sm text-slate-700 flex-1 max-sm:text-[13px] max-sm:leading-snug">
          <FormattedMessage id="cookieBanner.text" />{" "}
          <Link
            href={locale === "fr" ? "/privacy" : "/privacy/en"}
            className="underline decoration-slate-300 underline-offset-2 hover:text-slate-900"
          >
            <FormattedMessage id="cookieBanner.learnMore" />
          </Link>
        </p>
        <div className="flex items-center gap-3 shrink-0">
          {/* 44 px tall on phones (thumb targets), 36 px from sm. Same weight for both
              choices: refusing must be as easy as accepting. */}
          <button
            type="button"
            onClick={() => {
              dispatch(reject());
              sendAudienceConsent("rejected");
            }}
            className="min-h-11 flex-1 rounded-md px-4 py-2 text-sm font-medium text-slate-700 ring-1 ring-slate-300 hover:bg-slate-100 transition-colors sm:min-h-9 sm:flex-none"
          >
            <FormattedMessage id="cookieBanner.reject" />
          </button>
          <button
            type="button"
            onClick={() => {
              dispatch(accept());
              sendAudienceConsent("accepted");
            }}
            className="min-h-11 flex-1 rounded-md bg-btn-dark px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-btn-dark-hover transition-colors sm:min-h-9 sm:flex-none"
          >
            <FormattedMessage id="cookieBanner.accept" />
          </button>
        </div>
      </div>
    </div>
  );
}
